'use client';

import React, { memo } from 'react';

interface ImageCarouselPagingProps {
  index: number;
  activeSlide: number;
  onSlideChange: (currentSlide: number) => void;
}

const ImageCarouselPaging = ({ index, activeSlide, onSlideChange }: ImageCarouselPagingProps) => {
  return (
    <div
      // role="button"
      className={`inline-block h-3 w-3 cursor-pointer rounded-full transition-all duration-300 md:h-[15px] md:w-[15px] ${
        index === activeSlide ? 'bg-primary' : 'bg-[#A7BAB3]'
      } `}
      onClick={() => onSlideChange(index)}
    ></div>
  );
};

export default memo(ImageCarouselPaging);
